/* eslint-disable */

import Vue from 'vue'
import App from './App.vue'

import './styles/quasar.styl'
import 'quasar-framework/dist/quasar.ie.polyfills'
import lang from 'quasar-framework/i18n/ru'
import 'quasar-extras/animate'
import 'quasar-extras/roboto-font'
import 'quasar-extras/material-icons'
import 'quasar-extras/fontawesome'
import 'quasar-extras/ionicons'
import 'quasar-extras/mdi'
import VueRouter from 'vue-router'
import routes from './routes'
import admns from './components/admnotify'
import {store} from './store/store'
import VeeValidate, {Validator} from 'vee-validate'
import VTooltip from 'v-tooltip'
import VueHtmlToPaper from 'vue-html-to-paper';

import {
  Quasar, 
  QBtn,
  QLayout,
  QLayoutHeader,
  QLayoutDrawer,
  QPage,
  QPageContainer,
  QToolbar,
  QToolbarTitle,
  QList,
  QListHeader,
  QItemSeparator,
  QItem,
  QItemSide,
  QItemMain,
  QInput,
  QIcon,
  Dialog,
  CloseOverlay,
  Ripple,
  Notify,
  QModal,
  QModalLayout,
  QSelect,
  QBtnDropdown,
  QDatetimePicker,
  QBtnGroup,
  QItemTile,
  QSpinner,
  QSpinnerBall,
  QSpinnerHourglass,
  QSpinnerFacebook,
  QPopover,
  QSlider,
  QFab,
  QFabAction,
  QCheckbox,
  QDatetime,
  QSlideTransition,
  QBtnToggle,
  Loading,
  QTabs, QTab, QTabPane,
  QProgress,
  QTooltip,
  QCard,
  QCardTitle,
  QCardMain,
  QCardMedia,
  QCardSeparator,
  QCardActions,
  Screen,
  QPopupEdit,
  QCollapsible,
  QScrollObservable,
  AppFullscreen,
  QInfiniteScroll,
  QSpinnerDots,
  QOptionGroup,
  
} from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: {
    QBtn,
    QLayout,
    QLayoutHeader,
    QLayoutDrawer,
    QPage,
    QPageContainer,
    QToolbar,
    QToolbarTitle,
    QList,
    QListHeader,
    QItemSeparator,
    QItem,
    QItemSide,
    QItemMain,
    QInput,
    QIcon,
    Dialog,
    QModal,
    QModalLayout,
    QSelect,
    QBtnDropdown,
    QDatetimePicker,
    QBtnGroup,
    QItemTile,
    QSpinner,
    QSpinnerBall,
    QSpinnerFacebook,
    QSpinnerHourglass,
    QPopover,
    QSlider,
    QFab,
    QFabAction,
    QCheckbox,
    QDatetime,
    QSlideTransition,
    QBtnToggle,
    QTabs, QTab, QTabPane,
    QProgress,
    QTooltip,
    QPage,    
    QCard,
    QCardTitle,
    QCardMain,
    QCardMedia,
    QCardSeparator,
    QCardActions,
    QPopupEdit,
    QCollapsible,
    QScrollObservable,
    QInfiniteScroll,
    QSpinnerDots,
    QOptionGroup,
  },
  directives: {
    CloseOverlay, Ripple
  },
  plugins: {
    Dialog, Notify, CloseOverlay, Loading, Screen, AppFullscreen
  }, i18n: lang
 })

window.eventBus = new Vue();


Vue.use(VTooltip);

const dict = {
    custom: {
      priceName: {
        required: () => 'Укажите имя прайса'
      }
    }
};
Validator.localize('ru', dict);
Vue.use(VeeValidate, {
    events: 'change|custom'
  });


Vue.use(VueRouter);
const router = new VueRouter({
    routes,
    mode : 'history'
});

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (to.name=='logout') { // если мы отлогиниваемсся - то тупо отлогиниваемся...
          next();
      } else {
              let isAllow = store.getters.isAllowPermission(to.meta.permission);
  
              if (!store.getters.loggedIn) {
                  console.log('Не авторизован.');
                  next({
                      name: 'login',
                  })
              } else {      
                  if (!isAllow) { //попробуем найти компонент который подходит по правам
                      console.log('нет доступа к разделу');
                      let isError = true;
                      router.options.routes.forEach(element => {
                          if ((element.meta != undefined)&&(element.meta.permission))
                          if (store.getters.isAllowPermission(element.meta.permission)) {
                              isError = false;
                              next(element.name);
                              if (!isError) return false;
                          }
  
                      });
                      if (isError) next(false); // прерываем цепочку
                  }
                  else {
                      next();
                  }
              }
          }
      } else if (to.matched.some(record => record.meta.requiresVisitor)) {
              if (store.getters.loggedIn) {
                  next({
                      name: 'orders',
                  })
              } else {
                  next()
              }
          } else {
                  let isError = true;
                  router.options.routes.forEach(element => {
                      if ((element.meta != undefined)&&(element.meta.permission))
                          if (store.getters.isAllowPermission(element.meta.permission)) {
                              isError = false;
                              next(element.name);
                      }
                  });
                  if (isError) next(false); // прерываем цепочку
          }
});

Vue.use(admns); // подключаем мой нотификатор

// -------------------------------------------   Для распечатки страницы
const options = {
    name: '_blank',
    specs: [
      'fullscreen=yes',
      'titlebar=yes',
      'scrollbars=yes'
    ],
    styles: [
        'https://fonts.googleapis.com/icon?family=Material+Icons',
        'https://use.fontawesome.com/releases/v5.8.1/css/all.css',
        'https://cdn.jsdelivr.net/npm/quasar-framework@0.17.8/dist/umd/quasar.mat.min.css',   
        // 'https://cdn.jsdelivr.net/npm/@mdi/font@^2.0.0/css/materialdesignicons.min.css',
    ]
  }
  
  Vue.use(VueHtmlToPaper, options);
// ------------------------------------------- КОНЕЦ:  Для распечатки страницы

Vue.config.productionTip = false

new Vue({
  store : store,
  router : router,
  render: h => h(App)
})
.$mount('#app')
